import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './styles.sass'

const ExternalLink = props => {
  const { mode, to } = props
  return (
    <a
      className={cn('external-link', mode, props.className)}
      href={to}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  )
}

ExternalLink.propTypes = {
  mode: PropTypes.string,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

ExternalLink.defaultProps = {
  mode: 'red',
  className: null,
}

export default ExternalLink
